import { BASE_BE_URL } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import {
  BASE_AUTH_SUBURL,
  BASE_PAT_SUBURL,
  ALMSG_INTERNAL_ERR,
  ALMSG_UNAUTHORIZED_OP,
  BASE_ITASK_SUBURL,
} from "../env";
import { emptyPatient, emptyPatientFile, Patient, PatientFiles } from "./interfaces";

const formatMsgError = (msg: string[] | undefined) => {
  if (msg == undefined) return ALMSG_INTERNAL_ERR;
  else {
    return msg[0];
  }
};

export async function getAllPatients(
  signedInDoctor: SignedInDoctor,
  basic?: boolean
): Promise<Patient[]> {
  try {
    /*console.log(
      "Get all patients for medical studio ",
      JSON.stringify(signedInDoctor.medicalStudioId)
    );*/
    const response = await (
      await fetch(BASE_BE_URL + BASE_PAT_SUBURL + (basic ? "?basic=1" : ""), {
        method: "GET",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
    ).json();

    return response;
  } catch (error) {
    return [];
  }
}

export async function addPatient(
  signedInDoctor: SignedInDoctor,
  newPatient: Patient
): Promise<string> {
  try {
    //console.log("Create patient with data ", JSON.stringify(newPatient));
    const response = await fetch(BASE_BE_URL + BASE_PAT_SUBURL, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + signedInDoctor.token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newPatient),
    });

    if (response.ok) return JSON.stringify(await response.json());

    if (response.status == 400)
      return formatMsgError((await response.json()).message);
    else if (response.status == 401) return ALMSG_UNAUTHORIZED_OP;
    else return ALMSG_INTERNAL_ERR;
  } catch (error: any) {
    return ALMSG_INTERNAL_ERR;
  }
}

export async function editPatient(
  signedInDoctor: SignedInDoctor,
  editedPatient: Patient
): Promise<string> {
  try {
    //console.log("Edit patient with data ", JSON.stringify(editedPatient));
    const response = await fetch(
      BASE_BE_URL + BASE_PAT_SUBURL + editedPatient.id,
      {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editedPatient),
      }
    );

    if (response.ok) return JSON.stringify(await response.json());

    if (response.status == 400)
      return formatMsgError((await response.json()).message);
    else if (response.status == 401) return ALMSG_UNAUTHORIZED_OP;
    else return ALMSG_INTERNAL_ERR;
  } catch (error: any) {
    return ALMSG_INTERNAL_ERR;
  }
}

export async function deletePatient(
  signedInDoctor: SignedInDoctor,
  delPatient: Patient
): Promise<string> {
  try {
    //console.log("Deleting patient with data ", JSON.stringify(delPatient));
    const response = await fetch(
      BASE_BE_URL + BASE_PAT_SUBURL + delPatient.id,
      {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(delPatient),
      }
    );

    if (response.ok) return JSON.stringify(await response.json());

    if (response.status == 400)
      return formatMsgError((await response.json()).message);
    else if (response.status == 401) return ALMSG_UNAUTHORIZED_OP;
    else return ALMSG_INTERNAL_ERR;
  } catch (error: any) {
    return ALMSG_INTERNAL_ERR;
  }
}

export async function getPatient(
  signedInDoctor: SignedInDoctor,
  idPatient: number,
  files?: boolean
): Promise<Patient> {
  try {
    // console.log("Retrieving patient with id %d files? %d", idPatient, files);
    const response = await (
      await fetch(BASE_BE_URL + BASE_PAT_SUBURL + idPatient + "?files=" + (files? 1:0), {
        method: "GET",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
    ).json();
    //console.log("getPatient Response", response);
    return response;
  } catch (error) {
    console.log(error);
    return emptyPatient;
  }
}


export async function uploadFile(
  patientFile: File | undefined,
  fileName: string,
  signedInDoctor: SignedInDoctor,
  patientId: number,
  fileDescription?: string
): Promise<PatientFiles> {
  if (patientFile == undefined) return {...emptyPatientFile, error: "invalid patientFile"};
  else if(patientId < 0) return {...emptyPatientFile, error: "invalid patientId"};

  const formData = new FormData();

  formData.append("file", patientFile);
  if(fileDescription)
    formData.append("fileDescription", fileDescription);
  formData.append("pId", "" + patientId);
  formData.append(
    "forceFilename",
    patientId + "_" + fileName
  );
  try {
    const response = await fetch(
      BASE_BE_URL + BASE_PAT_SUBURL + patientId + "/upload-imgpdf", // to be changed
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
        },
        body: formData,
      }
    );

    console.log(response)
    if (response.ok) {
      let resp_json = await response.json();
      console.log("resp upload ", resp_json)
      return resp_json;
    } else if (response.status == 400) return {...emptyPatientFile, error: (await response.text())};
    else if (response.status == 401) return {...emptyPatientFile, error: ALMSG_UNAUTHORIZED_OP};
    else return {...emptyPatientFile, error: ALMSG_INTERNAL_ERR};
  } catch (error: any) {
    return {...emptyPatientFile, error: ALMSG_INTERNAL_ERR};
  }
}

export async function deleteFile(
  patientFileId: number,
  patientFileName: string,
  signedInDoctor: SignedInDoctor,
  patientId: number
) {
  try {
    const response = await fetch(
      BASE_BE_URL + BASE_PAT_SUBURL + patientId + "/delete-imgpdf/" + patientFileId, // to be changed
      {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({pId: patientId, fileId: patientFileId, fileName: patientFileName}),
      }
    );

    console.log(response)
    if (response.ok) {
      let resp_json = await response.json();
      console.log("resp delete ", resp_json)
      return resp_json;
    } else if (response.status == 400) return {...emptyPatientFile, error: (await response.text())};
    else if (response.status == 401) return {...emptyPatientFile, error: ALMSG_UNAUTHORIZED_OP};
    else return {...emptyPatientFile, error: ALMSG_INTERNAL_ERR};
  } catch (error: any) {
    return {...emptyPatientFile, error: ALMSG_INTERNAL_ERR};
  }
}


export async function getUploadedFile(
  patientId: number,
  fileName: string,
  signedInDoctor: SignedInDoctor
): Promise<[string, string] | undefined> {
  const fetchUrl =
    BASE_BE_URL + BASE_ITASK_SUBURL + "see-img/" + patientId + "/" + fileName;
  try {
    //console.log("Retrieving postural exam image " + fetchUrl);
    const blobResponse = await (
      await fetch(fetchUrl, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token
        },
      })
    ).blob();

    if(blobResponse.type == "application/pdf")
      console.log("Hey Hey Hey questo file +e un pdf " + fileName)

    return blobResponse.type == "application/pdf" || blobResponse.type == "image/png" || blobResponse.type == "image/jpeg"  || blobResponse.type == "image/gif"  || blobResponse.type == "image/heif" || blobResponse.type == "image/heic" 
      ? [URL.createObjectURL(blobResponse), blobResponse.type]
      : ["", ""];
  } catch (error) {
    console.log(error);
    return ["", ""];
  }
}